"use strict";
import { BarChart2, DollarSign, Home, Lock } from "react-feather";
import { useLocation } from "react-router-dom";
import { useSporeColors } from "ui/src";
import { Document } from "ui/src/components/icons/Document";
import { Hub } from "ui/src/components/icons/Hub";
import { PapersText } from "ui/src/components/icons/PapersText";
import { Swap } from "ui/src/components/icons/Swap";
import { VoteIcon } from "ui/src/components/icons/Vote";
export const useMenuContent = () => {
  const props = {
    size: 20,
    color: useSporeColors().neutral2.val
  };
  const { pathname } = useLocation();
  return [
    {
      title: "Home",
      href: "https://www.topazdex.com",
      icon: <Home {...props} />
    },
    {
      title: "Dashboard",
      href: "/dashboard",
      icon: <PapersText {...props} />,
      isActive: pathname.startsWith("/dashboard")
    },
    // {
    //   title: 'Explore',
    //   href: '/explore',
    //   icon: <Explore {...props} />,
    //   isActive: pathname.startsWith('/explore') || pathname.startsWith('/nfts'),
    // },
    {
      title: "Trade",
      href: "/swap",
      icon: <Swap {...props} />,
      isActive: pathname.startsWith("/swap")
    },
    // Temporarily hidden while the bridge is tested. Route stays live at /bridge;
    // re-enable this item (and the Bridge icon import above) once it's mature.
    // {
    //   title: 'Bridge',
    //   href: '/bridge',
    //   icon: <Bridge {...props} />,
    //   isActive: pathname.startsWith('/bridge'),
    // },
    {
      title: "Liquidity",
      href: "/liquidity",
      icon: <Hub {...props} />,
      isActive: pathname.startsWith("/liquidity")
    },
    {
      title: "Lock",
      href: "/locks",
      icon: <Lock {...props} />,
      isActive: pathname.startsWith("/lock")
    },
    {
      title: "Vote",
      href: "/vote",
      icon: <VoteIcon {...props} />,
      isActive: pathname.startsWith("/vote")
    },
    {
      title: "Incentives",
      href: "/incentives",
      icon: <DollarSign {...props} />,
      isActive: pathname.startsWith("/incentives")
    },
    {
      title: "Documents",
      href: "https://www.topazdex.com/docs",
      icon: <Document {...props} />
    },
    {
      title: "Stats",
      href: "https://www.topazdex.com/stats",
      icon: <BarChart2 {...props} />
    }
  ];
};
